import type { FaireProductEntity } from "../../entity_types/product";

export const p_3b2u8mb5bk: FaireProductEntity = {
  token: "p_3b2u8mb5bk",
  type: "product",
  name: "Knot Moccasins - Genuine Leather Baby Shoes (Latte)",
  brandToken: "b_5ytgyrzl",
  brandName: "BirdRock Baby",
  imageUrl:
    "https://cdn.faire.com/fastly/7a35180a709f477253b8f7a3e2ddf49a3a9f46b5363baa1b076a259198d3d928.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88eb23e1675921d05372d230bf278202a4fb78b42a7a4de6ac6ced8efef2df73.jpeg",
    "https://cdn.faire.com/fastly/95b88ced2cebd6d600a752ad630a95867dcd9ebd4facef9966fe70ee29a727ae.jpeg",
    "https://cdn.faire.com/fastly/f0bb3d2f5051eafe6331136e33c5277de3dd47a067688440a6a03eef2fb93482.jpeg",
    "https://cdn.faire.com/fastly/d8cf436bbc1b0118f9bd301c301302532fb419973eb226ce294bbfc959b99f56.jpeg",
    "https://cdn.faire.com/fastly/d056d369fa32d5abab8ef84e44f1f5833d45e989f3b72ccc2a98efac3148439c.png",
  ],
  priceDollars: 15,
  description:
    'Our cafe-inspired Latte Knot Moccasin combines the perfect blend of style and comfort. The latte is versatile enough for everyday wear yet timeless enough to match the perfect outfit.\n\nSizing: \nUS 2 (0-6 Months, 3.75" Sole).\nUS 3 (3-6 Months; 4.125" Sole)\nUS 4 (6-12 Months, 4.5" Sole).\nUS 5.5 (12-18 Months, 5.0" Sole).\nUS 6.5 (18-24 Months, 5.25" Sole).\nUS 8 (2-3 Years, 5.75" Sole).\n',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:54.239Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
